import { render, staticRenderFns } from "./FAQMenu.vue?vue&type=template&id=5525ebae&scoped=true&"
import script from "./FAQMenu.vue?vue&type=script&lang=js&"
export * from "./FAQMenu.vue?vue&type=script&lang=js&"
import style0 from "./FAQMenu.vue?vue&type=style&index=0&id=5525ebae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525ebae",
  null
  
)

export default component.exports